export const foods = [
    { id: 0,  name: 'Ramen',       emoji: '🍜', osmTags: ['ramen', 'japanese', 'noodle'] },
    { id: 1,  name: 'Sushi',       emoji: '🍣', osmTags: ['sushi', 'japanese'] },
    { id: 2,  name: 'Dim Sum',     emoji: '🥟', osmTags: ['dim_sum', 'chinese', 'cantonese'] },
    { id: 3,  name: 'Pho',         emoji: '🍲', osmTags: ['vietnamese', 'pho'] },
    { id: 4,  name: 'Korean BBQ',  emoji: '🥓', osmTags: ['korean', 'korean_bbq', 'bbq'] },
    { id: 5,  name: 'Thai',        emoji: '🌶️', osmTags: ['thai'] },
    { id: 6,  name: 'Hot Pot',     emoji: '🫕', osmTags: ['hotpot', 'hot_pot', 'chinese'] },
    { id: 7,  name: 'Boba Tea',    emoji: '🧋', osmTags: ['bubble_tea', 'tea', 'taiwanese'] },
    { id: 8,  name: 'Curry',       emoji: '🍛', osmTags: ['indian', 'curry', 'pakistani'] },
    { id: 9,  name: 'Shawarma',    emoji: '🌯', osmTags: ['shawarma', 'middle_eastern', 'lebanese'] },
    { id: 10, name: 'Falafel',     emoji: '🧆', osmTags: ['falafel', 'middle_eastern', 'mediterranean'] },
    { id: 11, name: 'Pizza',       emoji: '🍕', osmTags: ['pizza', 'italian'] },
    { id: 12, name: 'Burger',      emoji: '🍔', osmTags: ['burger', 'american'] },
    { id: 13, name: 'Pasta',       emoji: '🍝', osmTags: ['italian', 'pasta'] },
    { id: 14, name: 'Steak',       emoji: '🥩', osmTags: ['steak', 'american', 'grill'] },
    { id: 15, name: 'Tacos',       emoji: '🌮', osmTags: ['mexican', 'taco'] },
    { id: 16, name: 'Seafood',     emoji: '🦞', osmTags: ['seafood', 'fish'] },
    { id: 17, name: 'Brunch',      emoji: '🥞', osmTags: ['breakfast', 'brunch', 'american'] },
    { id: 18, name: 'Sandwiches',  emoji: '🥪', osmTags: ['sandwich', 'deli'] },
    { id: 19, name: 'Greek',       emoji: '🫒', osmTags: ['greek', 'mediterranean'] },
    { id: 20, name: 'Crepes',      emoji: '🥞', osmTags: ['crepe', 'french'] },
    { id: 21, name: 'Ice Cream',   emoji: '🍦', osmTags: ['ice_cream', 'dessert', 'frozen_yogurt'] },
    { id: 22, name: 'Donuts',      emoji: '🍩', osmTags: ['donut', 'dessert'] },
    { id: 23, name: 'Dumplings',   emoji: '🥟', osmTags: ['chinese', 'dumpling', 'dim_sum'] },
];
